import React from "react";
import AdminCreditRequestsComp from "../../components/Admin/AdminCreditRequests";

export default function AdminCreditRequests() {
  return <AdminCreditRequestsComp />;
}
